// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eb76ccf3","396":"8cdd809b","455":"f99a93e6","857":"6c734b5e","977":"d3c084e9"}[chunkId] + ".chunk.js";
};